import {getDateSlash} from "../../../../utility/DateUtils";
import React from "react";

const TableHead = () => {
  return <table width="100%" border="0" cellPadding="3" cellSpacing="0" className="border">
      <tbody>
      <tr>
          <td><strong>Lịch Xổ Số {getDateSlash()}</strong></td>
          <td colSpan="2" align="center"><strong>Thống kê tần suất xổ số</strong></td>
          <td align="center"><strong>Gan cực đại</strong></td>
          <td align="center"><strong>Thống kê Loto</strong></td>
      </tr>
      <tr>
          <td><a className="hottoday_mien" href="/"
                 title="Xổ Số Miền Nam"><strong>Xổ Số Miền Nam</strong></a></td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Miền Nam">Tần suất Miền
              Nam</a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số Miền Nam" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/"
                 title="Thống kê Gan Cực Đại Xổ Số Miền Nam">GCĐ Miền Nam</a></td>
          <td><a href="/"
                 title="Thống Kê lô các cặp số của Xổ Số Miền Nam">Xem Loto Miền Nam</a></td>
      </tr>
      <tr>
          <td><a className="hottoday_tinh1" href="/"
                 title="Xổ Số Nam Định"><span className="icon finnish">Xổ Số Nam Định</span></a>
          </td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Nam Định">Tần suất Nam
              Định </a></td>
          <td><a href="/">Chi
              tiết!.. </a></td>
          <td><a href="/" title="Thống kê Gan Cực Đại Xổ Số Nam Định">GCĐ
              Nam Định </a></td>
          <td><a href="/" title="Thống Kê lô các cặp số của Xổ Số Nam Định">Xem
              Loto Nam Định </a></td>
      </tr>
      <tr>
          <td><a className="hottoday_tinh1" href="xo-so-mien-nam.php?pro=Đà Nẵng"
                 title="Xổ Số Đà Nẵng"><span className="icon finnish">Xổ Số Đà Nẵng</span></a>
          </td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Đà Nẵng">Tần suất Đà
              Nẵng </a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số  Đà Nẵng" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/" title="Thống kê Gan Cực Đại Xổ Số Đà Nẵng">GCĐ
              Đà Nẵng </a></td>
          <td><a href="/" title="Thống Kê lô các cặp số của Xổ Số Đà Nẵng">Xem
              Loto Đà Nẵng </a></td>
      </tr>
      <tr>
          <td><a className="hottoday_tinh1" href="xo-so-mien-nam.php?pro=Quảng Ngãi"
                 title="Xổ Số Quảng Ngãi"><span
              className="icon finnish">Xổ Số Quảng Ngãi</span></a></td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Quảng Ngãi">Tần suất Quảng
              Ngãi </a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số  Quảng Ngãi" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/" title="Thống kê Gan Cực Đại Xổ Số Quảng Ngãi">GCĐ
              Quảng Ngãi </a></td>
          <td><a href="/" title="Thống Kê lô các cặp số của Xổ Số Quảng Ngãi">Xem
              Loto Quảng Ngãi </a></td>
      </tr>
      <tr>
          <td><a className="hottoday_mien" href="/"
                 title="Xổ Số Miền Bắc"><strong>Xổ Số Miền Bắc</strong></a></td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Miền Nam">Tần suất Miền
              Nam</a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số Miền Nam" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/"
                 title="Thống kê Gan Cực Đại Xổ Số Miền Nam">GCĐ Miền Nam</a></td>
          <td><a href="/"
                 title="Thống Kê lô các cặp số của Xổ Số Miền Nam">Xem Loto Miền Nam</a></td>
      </tr>
      <tr>
          <td><a className="hottoday_tinh1" href="/"
                 title="Xổ Số Hà Nội"><span className="icon wait">Xổ Số Hà Nội</span></a></td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Hà Nội">Tần suất Hà Nội </a>
          </td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số  Hà Nội" target="_blank">Chi tiết!.. </a>
          </td>
          <td><a href="/" title="Thống kê Gan Cực Đại Xổ Số Hà Nội">GCĐ
              Hà Nội </a></td>
          <td><a href="/" title="Thống Kê lô các cặp số của Xổ Số Hà Nội">Xem
              Loto Hà Nội </a></td>
      </tr>
      <tr>
          <td><a className="hottoday_mien" href="/"
                 title="Xổ Số Miền Trung"><strong>Xổ Số Miền Trung</strong></a></td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Miền Nam">Tần suất Miền
              Nam</a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số Miền Nam" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/"
                 title="Thống kê Gan Cực Đại Xổ Số Miền Nam">GCĐ Miền Nam</a></td>
          <td><a href="/"
                 title="Thống Kê lô các cặp số của Xổ Số Miền Nam">Xem Loto Miền Nam</a></td>
      </tr>
      <tr>
          <td><a className="hottoday_tinh1" href="/"
                 title="Xổ Số Vũng Tàu"><span className="icon wait">Xổ Số Vũng Tàu</span></a></td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Vũng Tàu">Tần suất Vũng
              Tàu </a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số  Vũng Tàu" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/" title="Thống kê Gan Cực Đại Xổ Số Vũng Tàu">GCĐ
              Vũng Tàu </a></td>
          <td><a href="/" title="Thống Kê lô các cặp số của Xổ Số Vũng Tàu">Xem
              Loto Vũng Tàu </a></td>
      </tr>
      <tr>
          <td><a className="hottoday_tinh1" href="/"
                 title="Xổ Số Bạc Liêu"><span className="icon wait">Xổ Số Bạc Liêu</span></a></td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Bạc Liêu">Tần suất Bạc
              Liêu </a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số  Bạc Liêu" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/" title="Thống kê Gan Cực Đại Xổ Số Bạc Liêu">GCĐ
              Bạc Liêu </a></td>
          <td><a href="/" title="Thống Kê lô các cặp số của Xổ Số Bạc Liêu">Xem
              Loto Bạc Liêu </a></td>
      </tr>
      <tr>
          <td><a className="hottoday_tinh1" href="/"
                 title="Xổ Số Bến Tre"><span className="icon wait">Xổ Số Bến Tre</span></a></td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Bến Tre">Tần suất Bến
              Tre </a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số  Bến Tre" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/" title="Thống kê Gan Cực Đại Xổ Số Bến Tre">GCĐ
              Bến Tre </a></td>
          <td><a href="/" title="Thống Kê lô các cặp số của Xổ Số Bến Tre">Xem
              Loto Bến Tre </a></td>
      </tr>
      <tr>
          <td><a className="hottoday_mien" href="/"
                 title="Xổ Số Đức hạnh"><strong>Xổ Số Đức hạnh</strong></a></td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Miền Nam">Tần suất Miền
              Nam</a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số Miền Nam" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/"
                 title="Thống kê Gan Cực Đại Xổ Số Miền Nam">GCĐ Miền Nam</a></td>
          <td><a href="/"
                 title="Thống Kê lô các cặp số của Xổ Số Miền Nam">Xem Loto Miền Nam</a></td>
      </tr>
      <tr>
          <td><a className="hottoday_tinh1" href="/"
                 title="Xổ Số Đắk Lắk"><span className="icon finnish">Xổ Số Đắk Lắk</span></a>
          </td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Đắk Lắk">Tần suất Đắk
              Lắk </a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số  Đắk Lắk" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/" title="Thống kê Gan Cực Đại Xổ Số Đắk Lắk">GCĐ
              Đắk Lắk </a></td>
          <td><a href="/" title="Thống Kê lô các cặp số của Xổ Số Đắk Lắk">Xem
              Loto Đắk Lắk </a></td>
      </tr>
      <tr>
          <td><a className="hottoday_tinh1" href="/"
                 title="Xổ Số Quảng Nam"><span className="icon finnish">Xổ Số Quảng Nam</span></a>
          </td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Quảng Nam">Tần suất Quảng
              Nam </a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số  Quảng Nam" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/" title="Thống kê Gan Cực Đại Xổ Số Quảng Nam">GCĐ
              Quảng Nam </a></td>
          <td><a href="/" title="Thống Kê lô các cặp số của Xổ Số Quảng Nam">Xem
              Loto Quảng Nam </a></td>
      </tr>
      <tr>
          <td><a className="hottoday_tinh1" href="/"
                 title="Xổ Số Bình Thuận"><span
              className="icon finnish">Xổ Số Bình Thuận</span></a></td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Bình Thuận">Tần suất Bình
              Thuận </a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số  Bình Thuận" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/" title="Thống kê Gan Cực Đại Xổ Số Bình Thuận">GCĐ
              Bình Thuận </a></td>
          <td><a href="/" title="Thống Kê lô các cặp số của Xổ Số Bình Thuận">Xem
              Loto Bình Thuận </a></td>
      </tr>
      <tr>
          <td><a className="hottoday_mien" href="/" title="Xổ Số Cảm ơn"><strong>Xổ
              Số Cảm ơn</strong></a></td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Miền Nam">Tần suất Miền
              Nam</a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số Miền Nam" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/"
                 title="Thống kê Gan Cực Đại Xổ Số Miền Nam">GCĐ Miền Nam</a></td>
          <td><a href="/"
                 title="Thống Kê lô các cặp số của Xổ Số Miền Nam">Xem Loto Miền Nam</a></td>
      </tr>
      <tr>
          <td><a className="hottoday_tinh1" href="/"
                 title="Xổ Số Vũng Tàu"><span className="icon wait">Xổ Số Vũng Tàu</span></a></td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Vũng Tàu">Tần suất Vũng
              Tàu </a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số  Vũng Tàu" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/" title="Thống kê Gan Cực Đại Xổ Số Vũng Tàu">GCĐ
              Vũng Tàu </a></td>
          <td><a href="/" title="Thống Kê lô các cặp số của Xổ Số Vũng Tàu">Xem
              Loto Vũng Tàu </a></td>
      </tr>
      <tr>
          <td><a className="hottoday_tinh1" href="/"
                 title="Xổ Số Bạc Liêu"><span className="icon wait">Xổ Số Bạc Liêu</span></a></td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Bạc Liêu">Tần suất Bạc
              Liêu </a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số  Bạc Liêu" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/" title="Thống kê Gan Cực Đại Xổ Số Bạc Liêu">GCĐ
              Bạc Liêu </a></td>
          <td><a href="/" title="Thống Kê lô các cặp số của Xổ Số Bạc Liêu">Xem
              Loto Bạc Liêu </a></td>
      </tr>
      <tr>
          <td><a className="hottoday_tinh1" href="/"
                 title="Xổ Số Bến Tre"><span className="icon wait">Xổ Số Bến Tre</span></a></td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Bến Tre">Tần suất Bến
              Tre </a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số  Bến Tre" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/" title="Thống kê Gan Cực Đại Xổ Số Bến Tre">GCĐ
              Bến Tre </a></td>
          <td><a href="/" title="Thống Kê lô các cặp số của Xổ Số Bến Tre">Xem
              Loto Bến Tre </a></td>
      </tr>
      <tr>
          <td><a className="hottoday_mien" href="/"
                 title="Xổ Số Miền Phía Dông"><strong>Xổ Số Miền Phía Dông</strong></a></td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Miền Nam">Tần suất Miền
              Nam</a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số Miền Nam" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/"
                 title="Thống kê Gan Cực Đại Xổ Số Miền Nam">GCĐ Miền Nam</a></td>
          <td><a href="/"
                 title="Thống Kê lô các cặp số của Xổ Số Miền Nam">Xem Loto Miền Nam</a></td>
      </tr>
      <tr>
          <td><a className="hottoday_tinh1" href="/"
                 title="Xổ Số Vĩnh Yên"><span className="icon wait">Xổ Số Vĩnh Yên</span></a></td>
          <td className="norightborder"><a
              href="/"
              title="Thống kê tần suất xuất hiện các cặp số của Xổ Số Vĩnh Yên">Tần suất Vĩnh
              Yên </a></td>
          <td><a href="/"
                 title="Thống kê tần suất chi tiết xổ số  Vĩnh Yên" target="_blank">Chi
              tiết!.. </a></td>
          <td><a href="/" title="Thống kê Gan Cực Đại Xổ Số Vĩnh Yên">GCĐ
              Vĩnh Yên </a></td>
          <td><a href="/" title="Thống Kê lô các cặp số của Xổ Số Vĩnh Yên">Xem
              Loto Vĩnh Yên </a></td>
      </tr>
      </tbody>
  </table>
}

export default TableHead;